import _extends from "@babel/runtime/helpers/esm/extends";
import { createElement } from "@wordpress/element";

/**
 * WordPress dependencies
 */
import { createHigherOrderComponent } from '@wordpress/compose';
import { createContext, RawHTML } from '@wordpress/element';
/**
 * Internal dependencies
 */

import { serialize } from '../api';

var _createContext = createContext(function () {}),
    Consumer = _createContext.Consumer,
    Provider = _createContext.Provider;
/**
 * An internal block component used in block content serialization to inject
 * nested block content within the `save` implementation of the ancestor
 * component in which it is nested. The component provides a pre-bound
 * `BlockContent` component via context, which is used by the developer-facing
 * `InnerBlocks.Content` component to render block content.
 *
 * @example
 *
 * ```jsx
 * <BlockContentProvider innerBlocks={ innerBlocks }>
 * 	{ blockSaveElement }
 * </BlockContentProvider>
 * ```
 *
 * @return {WPElement} Element with BlockContent injected via context.
 */


var BlockContentProvider = function BlockContentProvider(_ref) {
  var children = _ref.children,
      innerBlocks = _ref.innerBlocks;

  var BlockContent = function BlockContent() {
    // Value is an array of blocks, so defer to block serializer
    var html = serialize(innerBlocks, {
      isInnerBlocks: true
    }); // Use special-cased raw HTML tag to avoid default escaping

    return createElement(RawHTML, null, html);
  };

  return createElement(Provider, {
    value: BlockContent
  }, children);
};
/**
 * A Higher Order Component used to inject BlockContent using context to the
 * wrapped component.
 *
 * @return {Component} Enhanced component with injected BlockContent as prop.
 */


export var withBlockContentContext = createHigherOrderComponent(function (OriginalComponent) {
  return function (props) {
    return createElement(Consumer, null, function (context) {
      return createElement(OriginalComponent, _extends({}, props, {
        BlockContent: context
      }));
    });
  };
}, 'withBlockContentContext');
export default BlockContentProvider;
//# sourceMappingURL=index.js.map